export default __webpack_public_path__ + "static/media/lost-in-space.e4a081a0.gif";